(() => {
  function init(root) {
    const dialog = root.querySelector('[data-mug-dialog]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const form = root.querySelector('.tys-buy-form');
    const name = dialog.querySelector('[data-mug-name-input]');
    const style = dialog.querySelector('[data-mug-style]');
    const color = dialog.querySelector('[data-mug-color]');
    const logoInput = dialog.querySelector('[data-mug-logo-input]');
    const logoControl = dialog.querySelector('[data-mug-logo-control]');
    const logoFilename = dialog.querySelector('[data-mug-logo-filename]');
    const logoPreview = dialog.querySelector('[data-mug-logo-preview]');
    const error = dialog.querySelector('[data-mug-error]');
    const variantSelect = form.querySelector('[data-variant-select]');
    const previewOptions = [...form.querySelectorAll('[data-option-index]')];
    const isDemo = root.dataset.demo === 'true';
    const LOGO_STYLE = 'Logo als initiaal + naam';
    let saved = null;
    let opener = null;
    let logoUrl = '';
    const getColor = () => isDemo ? previewOptions.find(x => x.checked)?.value : variantSelect?.selectedOptions[0]?.textContent.trim();
    const optionRows = () => isDemo ? previewOptions.map(x => ({ value:x.value, text:x.value })) : [...(variantSelect?.options || [])].filter(x => !x.disabled).map(x => ({value:x.value,text:x.textContent.trim()}));
    const currentColorValue = () => isDemo ? getColor() : variantSelect?.value;
    const chosenText = () => color.selectedOptions[0]?.textContent || '';
    function render() {
      dialog.querySelector('[data-mug-name]').textContent = name.value.trim() || 'Jouw naam';
      const initial = dialog.querySelector('[data-mug-initial]');
      initial.textContent = [...name.value.trim()][0]?.toLocaleUpperCase('nl-NL') || 'J';
      const logoMode = style.value === LOGO_STYLE;
      logoControl.hidden = !logoMode;
      const logoFileSelected = logoMode && Boolean(logoUrl);
      logoInput.disabled = !logoMode;
      logoPreview.hidden = !logoFileSelected;
      if (logoFileSelected) logoPreview.src = logoUrl;
      else logoPreview.removeAttribute('src');
      initial.hidden = style.value !== 'Initiaal + naam' && !(logoMode && !logoFileSelected);
      dialog.querySelector('[data-mug-logo-filename]').textContent = logoInput.files?.[0]?.name || 'Geen logo gekozen.';
      dialog.querySelector('[data-mug-print]').toggleAttribute('data-light', /^(Wit|Geel)$/i.test(chosenText()));
      let photo;
      if (isDemo) photo = previewOptions.find(x => x.value === color.value)?.closest('label').querySelector('.tys-product-photo');
      else {
        const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
        const variant = variants.find(x => String(x.id) === color.value);
        photo = root.querySelector(`[data-media-id="${variant?.featured_image?.id}"] .tys-product-photo, [data-media-id="${variant?.featured_image?.id}"] img`);
        if (!photo) photo = root.querySelector('[data-active] img');
      }
      const area = dialog.querySelector('[data-mug-preview-photo]');
      area.replaceChildren();
      if (photo) area.append(photo.cloneNode(true));
    }
    function clearLogoPreview() {
      if (logoUrl) URL.revokeObjectURL(logoUrl);
      logoUrl = '';
      logoInput.value = '';
    }
    function writeProperties() {
      if (!saved) return;
      const values = { name:saved.name, style:saved.style, color:getColor() || saved.color, initial:saved.style === 'Initiaal + naam' ? [...saved.name][0].toLocaleUpperCase('nl-NL') : '' };
      Object.entries(values).forEach(([key,value]) => { form.querySelector(`[data-mug-property="${key}"]`).value = value; });
      const logoNote = saved.style === LOGO_STYLE && saved.logoName ? ` · ${saved.logoName}` : '';
      root.querySelector('[data-personalisation-summary]').textContent = `${values.name} · ${values.style} · ${values.color}${logoNote}`;
      root.querySelector('[data-open-personaliser]').textContent = 'Bewerk mijn ontwerp ↗';
    }
    function open(trigger) {
      opener = trigger;
      color.replaceChildren(...optionRows().map(x => { const option = document.createElement('option'); option.value=x.value; option.textContent=x.text; return option; }));
      color.value = currentColorValue();
      name.value = saved?.name || '';
      style.value = saved?.style || 'Naam';
      error.hidden = true;
      render();
      dialog.showModal();
      name.focus();
    }
    root.querySelectorAll('[data-open-personaliser]').forEach(button => button.addEventListener('click', () => open(button)));
    dialog.querySelectorAll('[data-close-personaliser]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('close', () => opener?.focus());
    dialog.addEventListener('click', event => { if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();} });
    [name,style,color].forEach(input => input.addEventListener('input',render));
    style.addEventListener('change', () => {
      if (style.value !== LOGO_STYLE && logoInput.files?.length) {
        clearLogoPreview();
        if (saved?.style === LOGO_STYLE) saved = null;
      }
      render();
    });
    logoInput.addEventListener('change', () => {
      const file = logoInput.files?.[0];
      if (logoUrl) URL.revokeObjectURL(logoUrl);
      logoUrl = file ? URL.createObjectURL(file) : '';
      saved = null;
      render();
    });
    dialog.querySelector('[data-save-personalisation]').addEventListener('click', () => {
      const value = name.value.trim();
      if (!value || value.length > 24 || /[\u0000-\u001f\u007f]/.test(value)) { error.textContent='Vul een naam in van 1 tot 24 tekens.';error.hidden=false;name.focus();return; }
      const logoFile = logoInput.files?.[0];
      if (style.value === LOGO_STYLE && !logoFile) { error.textContent='Upload eerst je logo om deze opmaak te gebruiken.';error.hidden=false;logoInput.focus();return; }
      if (logoFile && !logoFile.type.startsWith('image/')) { error.textContent='Kies een afbeeldingsbestand voor je logo.';error.hidden=false;logoInput.focus();return; }
      saved = {name:value,style:style.value,color:chosenText(),logoName:style.value === LOGO_STYLE ? logoFile?.name : ''};
      if (isDemo) {const radio=previewOptions.find(x=>x.value===color.value);if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}}
      else if (variantSelect) {variantSelect.value=color.value;variantSelect.dispatchEvent(new Event('change',{bubbles:true}));}
      writeProperties();dialog.close();
    });
    form.addEventListener('change',writeProperties);
    form.addEventListener('submit', event => {
      if (!saved) {event.preventDefault();event.stopImmediatePropagation();open(root.querySelector('[data-open-personaliser]'));error.textContent='Bewaar eerst jouw ontwerp.';error.hidden=false;}
      else writeProperties();
    },true);
    const repeat = root.querySelector('.repeat .cta');
    repeat?.addEventListener('click',event=>{event.preventDefault();open(repeat);});
  }
  const scan=scope=>{if(scope.matches?.('[data-tys-product]'))init(scope);scope.querySelectorAll('[data-tys-product]').forEach(init);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
